import api from '../api/axios';

export const getTodayMonitor = (userId) =>
  api.get(`/api/work/today-monitor/${userId}`).then((r) => r.data);

export const getRecruiterWorkLog = (userId, fromDate, toDate) =>
  api.get(`/api/work/recruiter-log/${userId}`, {
    params: { from: fromDate || undefined, to: toDate || undefined },
  }).then((r) => r.data);

export const getUpcomingInterviews = (userId, days = 7) =>
  api.get('/api/interviews/upcoming', { params: { userId, days } }).then((r) => r.data);

export const getNotifications = (userId) =>
  api.get(`/api/notifications/${userId}`).then((r) => r.data);

export const markNotificationRead = (userId, notificationId) =>
  api.patch(`/api/notifications/${userId}/${notificationId}/read`).then((r) => r.data);

export const markAllNotificationsRead = (userId) =>
  api.patch(`/api/notifications/${userId}/read-all`).then((r) => r.data);

export const scheduleInterview = (candidateId, payload) =>
  api.patch(`/api/candidates/${candidateId}/schedule-interview`, payload).then((r) => r.data);

export const holdRequirement = (requirementId) =>
  api.patch(`/api/requirements/${requirementId}/hold`).then((r) => r.data);
